import React from "react"
import { Tabber2, TabberAlignment, TabberVariant, TabItem2 } from "../../../designSystem/Tabber2";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Label } from "../../../designSystem/Label";

export const TabOverview = (): JSX.Element => 
{
    const [selectedTab, setSelectedTab] = React.useState<string>('Tab1');

    const items:TabItem2[] = [
        {tabName:'Tab1', text:'Tab 1'},
        {tabName:'Tab2', text:'Tab 2', avatarCount:64},
        {tabName:'Tab3', text:'Tab 3', avatarCount:4},
        {tabName:'Tab4', text:'Tab 4', icon:'interface_actions_edit'},
        {tabName:'Tab5', text:'Tab 5', avatarCount:8, icon:'interface_actions_like', disabled:true},
    ];

    return (
        <Flex flexDirection="column" gap={48}>
            {['button', 'text'].map(variant =>
                ['left', 'center', 'right', 'stretch'].map(alignment => 
                    <div key={`${variant}_${alignment}`} style={{border:'1px solid #000', padding: '16px', borderRadius:'4px' }}>
                        <Label>{variant} | alignment: {alignment}</Label>
                        <Tabber2
                            items={items}
                            selectedTabName={selectedTab}
                            onClick={(tabName) => setSelectedTab(tabName)}
                            variant={variant as TabberVariant}
                            alignment={alignment as TabberAlignment}
                        />
                    </div>
                )
            )}
        </Flex>
    )
}
